exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account[data-v-64793bd6] {\n  font-size: 0.2rem;\n  color: #929dad;\n  word-break: break-all;\n}\n.title[data-v-64793bd6] {\n  display: inline-block;\n  max-width: 100%;\n  font-size: 0.28rem;\n  font-family: Roboto-Medium, Roboto;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 0.1rem;\n}\n", ""]);

// exports
